// extracted by mini-css-extract-plugin
export default {"root":"Backdrop_root__C2lAv"};